import { usePostExternalCrea } from '@framework/api-client';
import { getNetworkErrorMessage } from '@framework/auth';
import { FormErrorsAlert, FormHandler } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import { LinkButton, useBreadcrumbItem, useHistory } from '@framework/ui';
import { Card, Result, message } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import { UserRegistrationForm } from '../../../components/user/citizen/UserRegistrationForm';
import { PageLayout } from '../../../ui/layout/PageLayout';
import { CitizenRegisterSchema } from '../../login/schema/CitizenRegisterSchema';

const RegistrationPageCard = styled(Card)`
  max-width: 800px;
  margin-inline: auto;
`;

export interface IRegistrationPageProps {}

export function RegistrationPage(props: IRegistrationPageProps) {
  const history = useHistory();
  const { t } = useTranslation();

  const register = usePostExternalCrea();

  const [success, setSuccess] = useState(false);

  useBreadcrumbItem({
    path: '/login',
    title: 'Login',
  });

  useBreadcrumbItem({
    path: history.location.pathname,
    title: t('user.registration.breadcrumb', 'Registrazione Utente'),
  });

  if (success) {
    return (
      <PageLayout>
        <div style={{ paddingBottom: '50px' }}>
          <Card>
            <Result
              status="success"
              title={t(
                'user.registration.response.success.title',
                'Registrazione completata!',
              )}
              subTitle={t(
                'user.registration.response.success.sub-title',
                `Ti abbiamo inviato una mail con le istruzioni per attivare il tuo account. Una volta attivato, potrai effetturare il login sul portale.`,
              )}
              extra={
                <LinkButton
                  type="primary"
                  to="/login"
                  children={t(
                    'user.registration.response.success.submit-button',
                    'Torna alle Domande',
                  )}
                />
              }
            />
          </Card>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <div style={{ paddingBottom: '50px' }}>
        <RegistrationPageCard style={{ marginInline: 'auto' }}>
          <FormHandler
            schema={CitizenRegisterSchema}
            onSubmit={async values => {
              try {
                await register.mutateAsync({
                  data: values,
                });
                message.success(t('user.registration.response.success.title','Registrazione completata!')); // prettier-ignore
                setSuccess(true);
              } catch (e) {
                console.error('Errore durante la registrazione', e);
                const defaultErrorMessage = t(
                  'user.registration.response.error.message',
                  'Si è verificato un errore durante la registrazione',
                );
                message.error(getNetworkErrorMessage(e, defaultErrorMessage)); // prettier-ignore
              }
            }}
          >
            <FormErrorsAlert />
            <UserRegistrationForm />
          </FormHandler>
        </RegistrationPageCard>
      </div>
    </PageLayout>
  );
}
